import React, { useEffect } from "react";
import {
  ClerkProvider as ClerkProviderOriginal,
  useAuth,
} from "@clerk/clerk-react";
import api from "../services/api";
import { registerPush } from "../utils/push";

const UserSync = ({ children }) => {
  const { isSignedIn, getToken } = useAuth();

  useEffect(() => {
    const syncUser = async () => {
      if (!isSignedIn || typeof getToken !== "function") {
        return;
      }

      try {
        const token = await getToken();
        if (!token) {
          return;
        }

        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        await api.post("/auth/sync-clerk-user");
        await registerPush(token, { forceRefresh: true });
      } catch (error) {
        // Ignore sync and push registration failures here; the app can still load.
      }
    };

    syncUser();
  }, [getToken, isSignedIn]);

  return <>{children}</>;
};

const ClerkProviderWrapper = ({ children }) => {
  const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

  return (
    <ClerkProviderOriginal publishableKey={publishableKey}>
      <UserSync>{children}</UserSync>
    </ClerkProviderOriginal>
  );
};

export default ClerkProviderWrapper;
